import request from 'superagent';
import * as types from './actionTypes';
import _ from 'lodash';
import aws from 'aws-sdk';

const host = window.location.hostname
// const domain = host.split('.');
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const environ = (host.indexOf('staging.') > -1) ? 'staging' : (host.indexOf('develop.') > -1 || host.indexOf('.local') > -1) ? 'develop' : 'prod'
const region = (environ === 'prod') ? 'us-east-1' : 'us-west-2'
var firebase = require('firebase')
const fbConfig = {
  apiKey: 'AIzaSyDyB5ICCvjBrkPPnSu-X2CFZIICiOrXQJY',
  authDomain: 'automatedupdatesir.firebaseapp.com',
  databaseURL: (environ !== 'prod') ? 'https://automatedupdatesir.firebaseio.com' : 'https://myphoto-prod.firebaseio.com',
  projectId: 'automatedupdatesir',
  storageBucket: 'automatedupdatesir.appspot.com',
  messagingSenderId: '1063926218928',
  appId: '1:1063926218928:web:8f3206803c9d4176'
}
const API_URL_2 = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com' // 'http://localhost:8080'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'


const normalizeError = (pError) => {
  let err = pError;
  if (_.get(err, 'response.body.message')) {
    err = _.get(err, 'response.body');
  }
  return err;
};

const dispatchAction = (dispatch, action, res) => {
  dispatch({
    type: action,
    res,
  });
};

const setRequestUrl = (route, basePath) => {
  let basicRoute = basePath;
  if (typeof route === 'string') {
    basicRoute = route;
  } else {
    basicRoute += `?${Object.keys(route).map(key => `${key}=${route[key]}`).join('&')}`;
  }
  return basicRoute;
};

// Login  actions
export function login(data) {
  return dispatch =>
    request.post(`${API_URL_2}/auth/login`)
      .send(data)
      .then(res => dispatch(authSuccess(res.body.token, data.email, res.body.scope)))
      .catch(error => dispatch(authFailure(normalizeError(error))));
}

export function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('scope');
  return {
    type: types.LOGOUT,
  };
}

export function authSuccess(token, userName, scope) {
  // console.log('authsuccess');
  localStorage.setItem('token', token);
  localStorage.setItem('user', userName);
  localStorage.setItem('scope', scope);
  return {
    type: types.AUTH_SUCCESS,
    user: userName,
  };
}

export function authFailure(error) {
  return {
    type: types.AUTH_FAILURE,
    error,
  };
}

export function clearAuthErrors() {
  return {
    type: types.AUTH_CLEAR_ERRORS,
  };
}

export function authInfo(dispatch = null) {
  //console.log('authInfo');
  const token = localStorage.getItem('token');
  //console.log('token: ', token);
  const userName = localStorage.getItem('user');
  // console.log('userName: ', userName);
  const scope = localStorage.getItem('scope');
  //console.log('scope: ', scope);
  if (token) {
    // console.log('dispatching authSuccess...');
    dispatch(authSuccess(token, userName, scope));
  }
  return token;
}

// Logging actions
export function fetchCampaignLogs(route) {
  let routeUrl = `${API_URL_2}/logging/campaigns?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/logging/campaigns`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.LOGS_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.LOGS_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchCampaignLog(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/logging/campaigns/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.LOG_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.LOG_FETCH_ERROR, normalizeError(error)));
  };
}

export function clearLoggingErrors() {
  return {
    type: types.LOGS_CLEAR_ERRORS,
  };
}

// Admins actions

export function fetchAdmins(route) {
  let routeUrl = `${API_URL_2}/admins?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/admins`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.ADMINS_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.ADMINS_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchAdmin(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/admins/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.ADMIN_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.ADMIN_FETCH_ERROR, normalizeError(error)));
  };
}

export function setAdmin(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/admins`)
      .set({ Authorization: token })
      .send(data)
      .then(res => dispatchAction(dispatch, types.ADMIN_SET_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.ADMIN_SET_ERROR, normalizeError(error)));
  };
}

export function deleteAdmin(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/admins/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.ADMIN_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.ADMIN_DELETE_ERROR, normalizeError(error)));
  };
}

export function editAdmin(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/admins/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.ADMIN_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.ADMIN_EDIT_ERROR, normalizeError(error)));
  };
}

export function clearAdminsErrors() {
  return {
    type: types.ADMINS_CLEAR_ERRORS,
  };
}


// Categories actions
export function fetchCategories(route) {
  let routeUrl = `${API_URL_2}/categories?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/categories`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.CATEGORIES_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.CATEGORIES_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchCategory(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/categories/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.CATEGORY_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.CATEGORY_FETCH_ERROR, normalizeError(error)));
  };
}

// export function fetchCategoryByIds(ids) {
//   return dispatch => {
//     const token = authInfo(dispatch);
//     request.get(`${API_URL_2}/categories`)
//     .send(ids)
//       .set({ Authorization: token })
//       .then(res => dispatchAction(dispatch, types.CATEGORY_FETCH_SUCCESS, res.body))
//       .catch(error => dispatchAction(dispatch, types.CATEGORY_FETCH_ERROR, normalizeError(error)));
//   };
// }

export function setCategory(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/categories`)
      .set({ Authorization: token })
      .send(data)
      .then(res => dispatchAction(dispatch, types.CATEGORY_SET_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.CATEGORY_SET_ERROR, normalizeError(error)));
  };
}

export function deleteCategory(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/categories/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.CATEGORY_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.CATEGORY_DELETE_ERROR, normalizeError(error)));
  };
}

export function editCategory(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/categories/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.CATEGORY_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.CATEGORY_EDIT_ERROR, normalizeError(error)));
  };
}

export function clearCategoriesErrors() {
  return {
    type: types.CATEGORIES_CLEAR_ERRORS,
  };
}

// Products actions

export function fetchProducts(route) {
  let routeUrl = `${API_URL_2}/products?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/products`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.PRODUCTS_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.PRODUCTS_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchProduct(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/products/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.PRODUCT_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.PRODUCT_FETCH_ERROR, normalizeError(error)));
  };
}


export function setProduct(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/products`)
      .set({ Authorization: token })
      .send(data)
      .then(res => dispatchAction(dispatch, types.PRODUCT_SET_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.PRODUCT_SET_ERROR, normalizeError(error)));
  };
}

export function deleteProduct(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/products/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.PRODUCT_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.PRODUCT_DELETE_ERROR, normalizeError(error)));
  };
}

export function editProduct(pData) {
  var data = pData;
  delete data.items;
  if (data.newAltImage) delete data.newAltImage;
  if (data.relatedCategory === null) delete data.relatedCategory;
  console.log('Sending product', data)
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/products/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.PRODUCT_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.PRODUCT_EDIT_ERROR, normalizeError(error)));
  };
}

export function disableProduct(pData) {
  const data = pData;
  delete data.items;
  if (data.relatedCategory === null) delete data.relatedCategory;
  data.defaultItemId = (!_.isNumber(data.defaultItemId)) ? 0 : data.defaultItemId;
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/products/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.PRODUCT_DISABLE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.PRODUCT_DISABLE_ERROR, normalizeError(error)));
  };
}

export function clearProductsErrors() {
  return {
    type: types.PRODUCTS_CLEAR_ERRORS,
  };
}
// Catalogs actions
export function fetchCatalogsByItemId(id) {
  const routeUrl = `${API_URL_2}/catalogs/item/${id}`;
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.ITEM_CATALOGS_FETCH_SUCCESS, { data: res.body, id }))
      .catch(error => dispatchAction(dispatch, types.ITEM_CATALOGS_FETCH_ERROR, normalizeError(error)));
  };
}
// TODO: get catalogs by productId
export function fetchCatalogsByProductId(id) {
  const routeUrl = `${API_URL_2}/catalogs/product/${id}`;
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.PRODUCT_CATALOGS_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.PRODUCT_CATALOGS_FETCH_ERROR, normalizeError(error)));
  };
}
export function fetchCatalogs(route) {
  let routeUrl = `${API_URL_2}/catalogs?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/catalogs`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.CATALOGS_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.CATALOGS_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchCatalog(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/catalogs/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.CATALOG_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.CATALOG_FETCH_ERROR, normalizeError(error)));
  };
}
// TODO: get catalogs by itemId
// export function fetchCatalogsByItemId(id) {
//   let routeUrl = `${API_URL_2}/catalogs?page=1`;
//   if (route) {
//     routeUrl = setRequestUrl(route, `${API_URL_2}/catalogs/item/${id}`);
//   }
//   return dispatch => {
//     const token = authInfo(dispatch);
//     request.get(routeUrl)
//       .set({ Authorization: token })
//       .then(res => dispatchAction(dispatch, types.ITEM_CATALOGS_FETCH_SUCCESS, res.body))
//       .catch(error => dispatchAction(dispatch, types.ITEM_CATALOGS_FETCH_ERROR, normalizeError(error)));
//   };
// }
// TODO: get catalogs by productId
// export function fetchCatalogsByProductId(id) {
//   let routeUrl = `${API_URL_2}/catalogs?page=1`;
//   if (route) {
//     routeUrl = setRequestUrl(route, `${API_URL_2}/catalogs/product/${id}`);
//   }
//   return dispatch => {
//     const token = authInfo(dispatch);
//     request.get(routeUrl)
//       .set({ Authorization: token })
//       .then(res => dispatchAction(dispatch, types.PRODUCT_CATALOGS_FETCH_SUCCESS, res.body))
//       .catch(error => dispatchAction(dispatch, types.PRODUCT_CATALOGS_FETCH_ERROR, normalizeError(error)));
//   };
// }


export function setCatalog(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/catalogs`)
      .set({ Authorization: token })
      .send(data)
      .then(res => dispatchAction(dispatch, types.CATALOG_SET_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.CATALOG_SET_ERROR, normalizeError(error)));
  };
}

export function deleteCatalog(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/catalogs/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.CATALOG_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.CATALOG_DELETE_ERROR, normalizeError(error)));
  };
}

export function editCatalog(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/catalogs/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.CATALOG_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.CATALOG_EDIT_ERROR, normalizeError(error)));
  };
}

export function disableCatalog(pData) {
  const data = pData;
  delete data.items;
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/catalogs/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.CATALOG_DISABLE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.CATALOG_DISABLE_ERROR, normalizeError(error)));
  };
}

export function addCatalogItem(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    if (data.maskHorizontal == null || data.maskHorizontal === '') delete data.maskHorizontal;
    if (data.maskVertical == null || data.maskVertical === '') delete data.maskVertical;
    request.patch(`${API_URL_2}/catalogs/${data.catalogId}/items`)
      .send(data.item)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.CATALOG_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.CATALOG_EDIT_ERROR, normalizeError(error)));
  };
}

export function deleteCatalogItem(catalogId, itemId) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/catalogs/${catalogId}/items/${itemId}`)
      .set({ Authorization: token })
      .catch(error => dispatchAction(dispatch, types.CATALOG_EDIT_ERROR, normalizeError(error)));
  };
}


export function clearCatalogsErrors() {
  return {
    type: types.CATALOGS_CLEAR_ERRORS,
  };
}


// Items actions

export function fetchItems(route) {
  let routeUrl = `${API_URL_2}/items?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/items`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    return request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => {
        dispatchAction(dispatch, types.ITEMS_FETCH_SUCCESS, res.body);
        return res.body.results
      })
      .catch(error => dispatchAction(dispatch, types.ITEMS_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchItem(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/items/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.ITEM_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.ITEM_FETCH_ERROR, error));
  };
}

export function setItem(pData) {
  var data = pData;
  if (data.printData.portrait.length !== data.printData.landscape.length) {
    data.printData.landscape = []
    data.printData.portrait.map((portrait) => {
      data.printData.landscape.push({
        width: portrait.width,
        height: portrait.height,
        rotate: portrait.rotate,
        sku: portrait.sku,
        index: portrait.index,
        pdfIndex: portrait.pdfIndex,
        x: portrait.x,
        y: portrait.y,
        bleed: portrait.bleed,
      })
    })
  }
  if (data.preview.portrait.length !== data.preview.landscape.length) {
    data.preview.landscape = []
    data.preview.portrait.map((portrait) => {
      data.preview.landscape.push({
        img: portrait.img,
        x: portrait.x,
        y: portrait.y,
        width: portrait.width,
        height: portrait.height,
        angle: portrait.angle,
        index: portrait.index,
        z: portrait.z,
        zoomedOverlay: portrait.zoomedOverlay,
        zoomedX: portrait.zoomedX,
        zoomedY: portrait.zoomedY,
        zoomedWidth: portrait.zoomedWidth,
        zoomedHeight: portrait.zoomedHeight,
      })
    })
  }
  data.productId = (data.productId === null) ? 0 : data.productId;
  // data.printData = JSON.stringify(data.printData);
  if (data.maskHorizontal == null || data.maskHorizontal === '') delete data.maskHorizontal;
  if (data.maskVertical == null || data.maskVertical === '') delete data.maskVertical;
  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/items`)
      .set({ Authorization: token })
      .send(data)
      .then(res => {
        dispatchAction(dispatch, types.ITEM_SET_SUCCESS, res.body);
      })
      .catch(error => dispatchAction(dispatch, types.ITEM_SET_ERROR, normalizeError(error)));
  };
}

export function disableItem(pData) {
  var data = pData;
  data.productId = (data.productId === null) ? 0 : data.productId;
  if (data.maskHorizontal == null || data.maskHorizontal === '') delete data.maskHorizontal;
  if (data.maskVertical == null || data.maskVertical === '') delete data.maskVertical;
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/items/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.ITEM_DISABLE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.ITEM_DISABLE_ERROR, normalizeError(error)));
  };
}

export function deleteItem(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/items/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.ITEM_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.ITEM_DELETE_ERROR, normalizeError(error)));
  };
}

export function editItem(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    if (data.foldername == null) delete data.foldername;
    if (data.maskHorizontal == null) delete data.maskHorizontal;
    if (data.maskVertical == null) delete data.maskVertical;
    if (data.socialImage == null) delete data.socialImage
    if (data.previewShape == null) delete data.previewShape
    request.patch(`${API_URL_2}/items/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.ITEM_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.ITEM_EDIT_ERROR, normalizeError(error)));
  };
}

export function clearItemsErrors() {
  return {
    type: types.ITEMS_CLEAR_ERRORS,
  };
}

// Tax Rate actions

export function fetchTaxrates(route) {
  let routeUrl = `${API_URL_2}/taxrate?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/taxrate`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => {
        dispatchAction(dispatch, types.TAXRATES_FETCH_SUCCESS, res.body);
      })
      .catch(error => dispatchAction(dispatch, types.TAXRATES_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchTaxrate(zipcode) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/taxrate/${zipcode}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.TAXRATE_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.TAXRATE_FETCH_ERROR, error));
  };
}

export function fetchTaxrateStates() {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/taxrate/states`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.TAXRATES_STATES_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.TAXRATES_STATES_FETCH_ERROR, error));
  };
}

export function setTaxrate(pData) {
  const data = pData;

  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/taxrate`)
      .set({ Authorization: token })
      .send(data)
      .then(res => {
        dispatchAction(dispatch, types.TAXRATE_SET_SUCCESS, res.body);
      })
      .catch(error => dispatchAction(dispatch, types.TAXRATE_SET_ERROR, normalizeError(error)));
  };
}
export function deleteTaxrate(zipcode) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/taxrate/${zipcode}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.TAXRATE_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.TAXRATE_DELETE_ERROR, normalizeError(error)));
  };
}

export function editTaxrate(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/taxrate/${data.zipcode}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.TAXRATE_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.TAXRATE_EDIT_ERROR, normalizeError(error)));
  };
}

export function clearTaxrateErrors() {
  return {
    type: types.TAXRATES_CLEAR_ERRORS,
  };
}

// Options actions

export function fetchOptions(route) {
  let routeUrl = `${API_URL_2}/options?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/options`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => {
        dispatchAction(dispatch, types.OPTIONS_FETCH_SUCCESS, res.body);
      })
      .catch(error => dispatchAction(dispatch, types.OPTIONS_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchOption(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/options/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.OPTION_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.OPTION_FETCH_ERROR, error));
  };
}

export function setOption(pData) {
  const data = pData;

  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/options`)
      .set({ Authorization: token })
      .send(data)
      .then(res => {
        dispatchAction(dispatch, types.OPTION_SET_SUCCESS, res.body);
      })
      .catch(error => dispatchAction(dispatch, types.OPTION_SET_ERROR, normalizeError(error)));
  };
}
export function deleteOption(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/options/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.OPTION_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.OPTION_DELETE_ERROR, normalizeError(error)));
  };
}

export function editOption(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/options/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.OPTION_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.OPTION_EDIT_ERROR, normalizeError(error)));
  };
}

export function clearOptionsErrors() {
  return {
    type: types.OPTIONS_CLEAR_ERRORS,
  };
}
// Options Group actions

export function fetchOptionGroups(route) {
  let routeUrl = `${API_URL_2}/optiongroups?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/optiongroups`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => {
        dispatchAction(dispatch, types.OPTIONGROUPS_FETCH_SUCCESS, res.body);
      })
      .catch(error => dispatchAction(dispatch, types.OPTIONGROUPS_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchOptionGroup(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/optiongroups/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.OPTIONGROUP_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.OPTIONGROUP_FETCH_ERROR, error));
  };
}

export function setOptionGroup(pData) {
  const data = pData;

  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/optiongroups`)
      .set({ Authorization: token })
      .send(data)
      .then(res => {
        dispatchAction(dispatch, types.OPTIONGROUP_SET_SUCCESS, res.body);
      })
      .catch(error => dispatchAction(dispatch, types.OPTIONGROUP_SET_ERROR, normalizeError(error)));
  };
}
export function deleteOptionGroup(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/optiongroups/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.OPTIONGROUP_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.OPTIONGROUP_DELETE_ERROR, normalizeError(error)));
  };
}

export function editOptionGroup(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/optiongroups/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.OPTIONGROUP_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.OPTIONGROUP_EDIT_ERROR, normalizeError(error)));
  };
}

export function clearOptionGroupsErrors() {
  return {
    type: types.OPTIONGROUPS_CLEAR_ERRORS,
  };
}
// Global Settings actions

export function fetchGlobalSettings() {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/settings/global`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.GLOBAL_SETTINGS_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.GLOBAL_SETTINGS_FETCH_ERROR, normalizeError(error)));
  };
}

export function editGlobalSettings(data) {
  console.log("data to be sent", data)
  Object.keys(data).forEach((key) => (data[key] == null || key === 'shippingOptions') && delete data[key])
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/settings/global`)
      .send(data)
      .set({ Authorization: token })
      .then(res => { console.log("Res from editGlobalSettings", res); dispatchAction(dispatch, types.GLOBAL_SETTINGS_EDIT_SUCCESS, res.body) })
      .catch(error => dispatchAction(dispatch, types.GLOBAL_SETTINGS_EDIT_ERROR, normalizeError(error)));
  };
}

export function clearGlobalSettingsErrors() {
  return {
    type: types.GLOBAL_SETTINGS_CLEAR_ERRORS,
  };
}

// Settings actions

export function fetchSettings(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/settings/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.SETTINGS_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.SETTINGS_FETCH_ERROR, normalizeError(error)));
  };
}

export function editSettings(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/settings/${data.salesChannelId}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.SETTINGS_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.SETTINGS_EDIT_ERROR, normalizeError(error)));
  };
}

export function clearSettingsErrors() {
  return {
    type: types.SETTINGS_CLEAR_ERRORS,
  };
}

export function editShippingOptions(data) {
  if (data.created_at) delete data.created_at
  if (data.updated_at) delete data.updated_at
  return dispatch => {
    const token = authInfo(dispatch);
    return request.patch(`${API_URL_2}/shipping/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.SHIPPING_OPTIONS_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.SHIPPING_OPTIONS_EDIT_ERROR, normalizeError(error)));
  }
}

// Sales Channel actions

export function fetchSalesChannels(route) {
  let routeUrl = `${API_URL_2}/saleschannels?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/saleschannels`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => {
        dispatchAction(dispatch, types.SALESCHANNELS_FETCH_SUCCESS, res.body);
      })
      .catch(error => dispatchAction(dispatch, types.SALESCHANNELS_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchSalesChannel(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/saleschannels/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.SALESCHANNEL_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.SALESCHANNEL_FETCH_ERROR, error));
  };
}

export function setSalesChannel(pData) {
  const data = pData;
  data.catalogId = (data.catalogId === null) ? 0 : data.catalogId;
  data.priceListId = (data.priceListId === null) ? 0 : data.priceListId;
  if (data.campaignId === '') delete data.campaignId;
  delete data.giftCard;
  delete data.pickPack;
  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/saleschannels`)
      .set({ Authorization: token })
      .send(data)
      .then(res => {
        dispatchAction(dispatch, types.SALESCHANNEL_SET_SUCCESS, res.body);
      })
      .catch(error => dispatchAction(dispatch, types.SALESCHANNEL_SET_ERROR, normalizeError(error)));
  };
}

export function disableSalesChannel(pData) {
  const data = pData;
  data.catalogId = (data.catalogId === null) ? 0 : data.catalogId;
  data.priceListId = (data.priceListId === null) ? 0 : data.priceListId;
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/saleschannels/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.SALESCHANNEL_DISABLE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.SALESCHANNEL_DISABLE_ERROR, normalizeError(error)));
  };
}

export function deleteSalesChannel(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/saleschannels/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.SALESCHANNEL_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.SALESCHANNEL_DELETE_ERROR, normalizeError(error)));
  };
}

export function editSalesChannel(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/saleschannels/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.SALESCHANNEL_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.SALESCHANNEL_EDIT_ERROR, normalizeError(error)));
  };
}

export function clearSalesChannelsErrors() {
  return {
    type: types.SALESCHANNELS_CLEAR_ERRORS,
  };
}

// Campaigns actions
export function fetchCampaigns(route) {
  let routeUrl = `${API_URL_2}/campaigns?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/campaigns`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.CAMPAIGNS_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.CAMPAIGNS_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchCampaign(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/campaigns/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.CAMPAIGN_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.CAMPAIGN_FETCH_ERROR, normalizeError(error)));
  };
}

export function setCampaign(data) {
  Object.keys(data).forEach((key) => (data[key] == null) && delete data[key]);
  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/campaigns`)
      .set({ Authorization: token })
      .send(data)
      .then(res => dispatchAction(dispatch, types.CAMPAIGN_SET_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.CAMPAIGN_SET_ERROR, normalizeError(error)));
  };
}

export function deleteCampaign(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/campaigns/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.CAMPAIGN_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.CAMPAIGN_DELETE_ERROR, normalizeError(error)));
  };
}

export function editCampaign(data) {
  if (data.emailSubjectPromo == null) delete data.emailSubjectPromo;
  if (data.emailHeadlinePromo == null) delete data.emailHeadlinePromo;
  if (data.emailBodyPromo == null) delete data.emailBodyPromo;
  if (data.email2Subject == null) delete data.email2Subject;
  if (data.email2Headline == null) delete data.email2Headline;
  if (data.email2Body == null) delete data.email2Body;
  if (data.email2SubjectPromo == null) delete data.email2SubjectPromo;
  if (data.email2HeadlinePromo == null) delete data.email2HeadlinePromo;
  if (data.email2BodyPromo == null) delete data.email2BodyPromo;
  if (data.email3Subject == null) delete data.email3Subject;
  if (data.email3Headline == null) delete data.email3Headline;
  if (data.email3Body == null) delete data.email3Body;
  if (data.email3SubjectPromo == null) delete data.email3SubjectPromo;
  if (data.email3HeadlinePromo == null) delete data.email3HeadlinePromo;
  if (data.email3BodyPromo == null) delete data.email3BodyPromo;
  if (data.email4Subject == null) delete data.email4Subject;
  if (data.email4Headline == null) delete data.email4Headline;
  if (data.email4Body == null) delete data.email4Body;
  if (data.email4SubjectPromo == null) delete data.email4SubjectPromo;
  if (data.email4HeadlinePromo == null) delete data.email4HeadlinePromo;
  if (data.email4BodyPromo == null) delete data.email4BodyPromo;
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/campaigns/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.CAMPAIGN_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.CAMPAIGN_EDIT_ERROR, normalizeError(error)));
  };
}

export function disableCampaign(pData) {
  const data = pData;
  delete data.items;
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/campaigns/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.CAMPAIGN_DISABLE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.CAMPAIGN_DISABLE_ERROR, normalizeError(error)));
  };
}

export function clearCampaignsErrors() {
  return {
    type: types.CAMPAIGNS_CLEAR_ERRORS,
  };
}

// Orders actions

export function fetchOrders(route) {
  let routeUrl = `${API_URL_2}/orders?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/orders`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.ORDERS_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.ORDERS_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchOrder(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/orders/${id}`)
      .set({ Authorization: token })
      .then(res => {
        dispatchAction(dispatch, types.ORDER_FETCH_SUCCESS, res.body)
        dispatch(fetchEventsById(res.body.id))
      });
    // .catch(error => dispatchAction(dispatch, types.ORDER_FETCH_ERROR, normalizeError(error)));
  };
}

export function setOrder(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/orders`)
      .set({ Authorization: token })
      .send(data)
      .then(res => dispatchAction(dispatch, types.ORDER_SET_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.ORDER_SET_ERROR, normalizeError(error)));
  };
}

export function deleteOrder(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/orders/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.ORDER_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.ORDER_DELETE_ERROR, normalizeError(error)));
  };
}

export function editOrder(orderId, data) {
  console.log('EDIT ORDER', orderId, data)
  // Object.keys(data).forEach((key) => (data[key] == null) && delete data[key]);
  // if(!data.transactions.length) {
  //   data.transactions = [];
  // }
  // if(!data.shipping.length){
  //   data.shipping= [data.shipping]
  // }
  // if(!data.customer.lastName && data.customer.last_name) data.customer.lastName = data.customer.last_name
  return dispatch => {
    // if (data.transactions.length > 0 && (data.transactions[0].dateTime === '' || data.transactions[0].dateTime === null)) {
    //   data.transactions[0].dateTime = Date.now();
    // }
    // if (data && data.alert === null) {
    //   delete data.alert;
    // }
    // if (data.billingAddress && data.billingAddress.email) delete data.billingAddress.email;
    // if (data.billingAddress && data.billingAddress.phone) delete data.billingAddress.phone;
    // if (data.customer && data.customer.last_name) delete data.customer.last_name;
    console.log("Updating order: ", data);
    const token = authInfo(dispatch);
    return request.patch(`${API_URL_2}/orders/${orderId}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.ORDER_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.ORDER_EDIT_ERROR, normalizeError(error)));
  };
}
export function updateOrderPayload(orderId, index, value) {
  console.log("UODATE ORDER PAYLOAD:", index, value)
  return dispatch => {
    const token = authInfo(dispatch);
    return request.patch(`${API_URL_2}/order/${orderId}`)
      .send({ payload: { index, value } })
      .set({ Authorization: token })
      .then(res => {
        console.log('updateOrder Success', res)
        dispatchAction(dispatch, types.ORDER_EDIT_SUCCESS, res.body)
        return 'success'
      })
      .catch(error => {
        console.log('updateOrder Error', error)
        dispatchAction(dispatch, types.ORDER_EDIT_ERROR, normalizeError(error))
      });
  };
}

export function disableOrder(orderId) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/order/${orderId}`)
      .send({ payload: { index: 'status', value: 'canceled' } })
      .set({ Authorization: token })
      .then(res => {
        dispatch(updateOrderPayload(orderId, 'alert', ''))
        dispatchAction(dispatch, types.ORDER_DISABLE_SUCCESS, res.body)
        console.log('Disable Order:', res);
      })
      .catch(error => dispatchAction(dispatch, types.ORDER_DISABLE_ERROR, normalizeError(error)));
  };
}
export function shippedOrder(orderId) {
  console.log('Disable Order:', orderId)
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/order/${orderId}`)
      .send({ payload: { index: 'status', value: 'shipped' } })
      .set({ Authorization: token })
      .then(res => {
        dispatch(updateOrderPayload(orderId, 'alert', ''))
        dispatchAction(dispatch, types.ORDER_DISABLE_SUCCESS, res.body)
      })
      .catch(error => dispatchAction(dispatch, types.ORDER_DISABLE_ERROR, normalizeError(error)));
  };
}

export function setFulfillment(data, sendTo) {
  if (!data.transactions.length) {
    data.transactions = [];
  }
  return dispatch => {
    if (data.transactions.length > 0 && (data.transactions[0].dateTime === '' || data.transactions[0].dateTime === null)) {
      data.transactions[0].dateTime = Date.now();
    }
    const token = authInfo(dispatch);
    const url = (sendTo === 'sage')
      ? `${API_URL_2}/orders/pending/${data.id}?sendToNetSuite=false&sendToSAGE=true&admin=true`
      : `${API_URL_2}/orders/pending/${data.id}?sendToNetSuite=true&sendToSAGE=false&admin=true`
    request.patch(url)
      .set({ Authorization: token })
      .then(res => {
        if (res.error) {
          const error = {
            message: res.body.processing.error,
          };
          dispatchAction(dispatch, types.ORDER_FULFILLMENT_SET_ERROR, error);
        } else {
          dispatchAction(dispatch, types.ORDER_FULFILLMENT_SET_SUCCESS, res.body);
        }
      })
      .catch(error => {
        console.log('error......', error);
        dispatchAction(dispatch, types.ORDER_FULFILLMENT_SET_ERROR, normalizeError(error));
      });
  };
}
export function syncWithNetsuite(itemId){
  console.log('syncWithNetsuite', itemId)
  return dispatch => {
    const token = authInfo(dispatch)
    request.post(`${API_URL_2}/items/netsuite/${itemId}`)
      .set({ Authorization: token })
      .then(res => console.log('Success sending itemId to Netsuite', res))
      .catch(error => console.log('ERROR sending itemId to Netsuite', error))
  }
}

export function bulkSendPending(page, sage = false) {
  console.log("HERE WE GO!!")
  return dispatch => {
    const routeUrl = `${API_URL_2}/orders?statuses=pending&page=${page}`
    const token = authInfo(dispatch);
    return request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => {
        // console.log('got back: ', res.body)
        const orders = res.body.results
        orders.forEach(data => {
          console.log('Processing ' + data.confirmId)
          const pendingUrl = `${API_URL_2}/orders/pending/${data.id}?sendToAFE=${!sage}&sendToSAGE=${sage}&admin=true`
          console.log('pendingUrl: ' + pendingUrl)
          return request.patch(pendingUrl)
            .set({ Authorization: token })
            .then(res => {
              if (res.error) {
                console.log('Error: ', res.body.processing.error)
              } else {
                console.log('Success...', res.body.status)
              }
            })
            .catch(error => {
              console.log('error......', error);
            });
        })
      })
      .catch(error => {
        console.log('Error fetching pending orders: ', error)
      });
  }
}

export function clearOrdersErrors() {
  return {
    type: types.ORDERS_CLEAR_ERRORS,
  };
}

export function regeneratePdf(pdf, order, i, orderItem, cb) {
  console.log('***hhhhh******', pdf)
  return dispatch => {
  console.log('regeneratePDF triggered with ', pdf);
  const lambda = new aws.Lambda({
    region: region,
    accessKeyId: process.env.AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY,
    apiVersion: '2015-03-31'
  });
  const pullParams = {
    FunctionName: `pdf-generator-${environ}`,
    InvocationType: 'RequestResponse',
    LogType: 'Tail',
    Payload: JSON.stringify(pdf),
  };
  console.log('Invoking Lambda function with Payload: ', pullParams.Payload);
  lambda.invoke(pullParams, (err, data) => {
    const res = JSON.parse(data.Payload) || {};
    console.log('Lambda results: ', data);
    if (err || res.errorMessage) {
      console.log('Got an error.');
      return cb(err, null);
    }
    console.log('Got return.', res.Location)
    // if(order.processing.pdf.pdfs.findIndex(p => p.itemId === orderItem.id) > -1) {
    //   return cb(null, data)
    // } else {
      dispatch(updateOrderProcessing(order, i, res, orderItem, cb))
    // }
  })
}
}

export function updateOrderProcessing(order, i, pdfData, orderItem, cb) {
  console.log('***pdfData****', pdfData.Location)
  return dispatch => {
    const token = authInfo(dispatch)
    var new_processing = order.processing
    const pdfIndex = new_processing.pdf.pdfs.findIndex(p => p.itemId === orderItem.id)
    if(pdfIndex !== -1) {
      new_processing.pdf.pdfs[pdfIndex] = {
        sku: orderItem.sku,
        itemId: orderItem.id,
        pdfUrl: pdfData.Location,
        status: "success",
        dateTime: new Date()
      }
    } else {
      new_processing.pdf.pdfs.push({
        sku: orderItem.sku,
        itemId: orderItem.id,
        pdfUrl: pdfData.Location,
        status: "success",
        dateTime: new Date()
      })
    }
    // update firebase
    if (!firebase.apps.length) {
      firebase.initializeApp(fbConfig)
    }
    const pii = orderItem.order_line_id || orderItem.orderLineId
    firebase.database().ref().child('items').child(pii.toString()).update({
      pdf_url: pdfData.Location
    }).then(()=>console.log('FIREBASE UPDATED'))
    .catch((err)=>console.log('ERROR UPDATING FIREBASE: ', err))
    // update order
    request.patch(`${API_URL_2}/order/${order.id}`)
      .send({ payload: { index: 'processing', value: new_processing } })
      .set({ Authorization: token })
      .then(res => {
        console.log('order items updated!');
        // return cb(null, pdfData)
      })
      .catch((e) => {
        console.log('ERROR: order items update ', e)
        // return cb(e, pdfData)
      })
  }
}
export function reportOrders(fromDate, toDate, submissionType) {
  return dispatch => {
    // (1) trigger lambda function for submissions order (adding day to toDate)
    const date_to = new Date(toDate);
    const date_to_string = `${date_to.getFullYear()}-${date_to.getMonth() + 1}-${date_to.getDate() + 1}`;
    console.log("Getting submissions through date: ", date_to_string);
    // const email = localStorage.getItem('user');
    // console.log("Sending to user: ", email);
    // const lambda = new aws.Lambda({
    //   region: 'us-east-1',
    //   accessKeyId: process.env.AWS_ACCESS_KEY_ID,
    //   secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY,
    //   apiVersion: '2015-03-31' });
    // const pullParams = {
    //   FunctionName: 'Focus-Report-Submissions',
    //   InvocationType: 'RequestResponse',
    //   LogType: 'Tail',
    //   Payload: JSON.stringify({ date_from: fromDate, date_to: date_to_string, to_email: email }),
    // };
    // console.log('Invoking Lambda function with Payload: ', pullParams.Payload);
    // lambda.invoke(pullParams, (err, data) => {
    //   console.log('Lambda results: ', data);
    // });
    // (2) run orders report
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/reports?fromDate=${fromDate}&toDate=${toDate}&submissionType=${submissionType}`)
      .set({ Authorization: token })
      .then(res => {
        console.log('DUMP TO EXCEL: ', res.body);
        dispatchAction(dispatch, types.REPORTS_FETCH_SUCCESS, res.body);
      })
      .catch(error => console.log('ERROR: ', normalizeError(error)));
  };
}
export function newGiftcards(data) {
  Object.keys(data).forEach((key) => (data[key] == null) && delete data[key]);
  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/giftcards`)
      .set({ Authorization: token })
      .send(data)
      .then(res => {
        console.log('DUMP GIFTCARDS TO EXCEL: ', res.body);
        dispatchAction(dispatch, types.GIFTCARD_NEW_SUCCESS, res.body);
      })
      .catch(error => console.log('ERROR: ', normalizeError(error)));
  };
}

export function uploadPhotosToS3(uploadFile) {
  const { bucket, key, awsAccessKeyId, policy, signature, file } = uploadFile;
  const baseUrl = `//${bucket}.s3.amazonaws.com/`;
  const formData = new FormData();
  formData.append('key', key);
  formData.append('AWSAccessKeyId', awsAccessKeyId);
  formData.append('policy', policy);
  formData.append('signature', signature);
  formData.append('acl', 'public-read');
  if (file.type) {
    formData.append('Content-Type', file.type);
    formData.append('file', file);
  }
  console.log('# trying to post to S3: ', baseUrl);
  return request
    .post(baseUrl)
    .send(formData)
    .then(() => ({
      bucket,
      key,
    }));
}

export function replaceOrderItem(file, order, thisItem, orderItem, index, oldOrder, cb) {
  const getKey = file => encodeURI(`${Date.now()}-${file.name}`.replace(/([^a-z0-9.]+)/gi, ''));
  console.log('get key item', getKey);
  return dispatch => {
    const token = authInfo(dispatch);
    const key = getKey(file[0]);
    // get AWS authorization
    request.post(`${API_URL_2}/auth/s3policy`)
      .send({ fileName: key })
      .set({ Authorization: token })
      .then((response) => {
        // now upload to S3
        uploadPhotosToS3({
          bucket: response.body.bucket,
          key,
          awsAccessKeyId: response.body.awsKey,
          policy: response.body.policy,
          signature: response.body.signature,
          file: file[0],
        })
          .then(() => {
            // update order.items[itemId] with new file
            let fileName = `https://${response.body.bucket}.s3.amazonaws.com/${key}`
            console.log('replacing file urls with: ', fileName)
            if (staging) fileName = fileName.replace('https:', 'http:')
            console.log('thisItem: ', thisItem)
            console.log('orderItem: ', orderItem)
            console.log('photoIndex: ', index)
            // let's find out about the product they are ordering:
            const prevWidth = thisItem.photopersonalization[index].images[0].actualSize.width;
            const prevHeight = thisItem.photopersonalization[index].images[0].actualSize.height;
            console.log('*** Prev W x H ', prevWidth, prevHeight);
            // start updating the order item:
            var new_photopersonalization = thisItem.photopersonalization
            new_photopersonalization[index].images[0].url = fileName;
            new_photopersonalization[index].images[0].originalUrl = fileName;
            const img = document.createElement('img');
            img.onload = function () {
              console.log(`3) image dimensions are: ${this.width} ${this.height}`);
              const imageActualWidth = this.width;
              const imageActualHeight = this.height;
              console.log('*** New W x H ', imageActualWidth, imageActualHeight);
              new_photopersonalization[index].images[0].actualSize.width = imageActualWidth
              new_photopersonalization[index].images[0].actualSize.height = imageActualHeight
              const isLandscape = (imageActualWidth > imageActualHeight)
              console.log('isLandscape: ', isLandscape);
              // get actual print width/height from item:
              const printWidth = isLandscape ? orderItem.printData.landscape[index].width : orderItem.printData.portrait[index].width;
              const printHeight = isLandscape ? orderItem.printData.landscape[index].height : orderItem.printData.portrait[index].height;
              console.log('*** printWidth, printHeight: ', printWidth, printHeight);
              // Got dimensions, now start updating...
              // handle new thisItem.photoPersonalization.images[0].actualSize.width / height
              const rotation = 0;
              const brightness = 1;
              let imageWidth = 100;
              let imageHeight = 100;
              let imageX = 0;
              let imageY = 0;
              const imageIsWider = ((imageActualWidth / imageActualHeight) > (printWidth / printHeight));
              console.log('imageIsWider: ', imageIsWider);
              if (imageIsWider) {
                imageHeight = 100;
                imageY = 0;
                imageWidth = printWidth * imageActualHeight * 100 / (printHeight * imageActualWidth);
                imageX = (100 - imageWidth) / 2;
              } else {
                imageHeight = printHeight * imageActualWidth * 100 / (printWidth * imageActualHeight);
                imageY = (100 - imageHeight) / 2;
                imageWidth = 100;
                imageX = 0;
              }
              new_photopersonalization[index].edits = {
                rotation,
                brightness,
                imageX,
                imageY,
                imageHeight,
                imageWidth,
              }
              console.log('updating order_item with new photopersonalization: ', new_photopersonalization);
              request.patch(`${API_URL_2}/order/${thisItem.id}`)
                .send({ payload: { index: 'photopersonalization', value: JSON.stringify(new_photopersonalization) } })
                .set({ Authorization: token })
                .then(response => {
                  console.log('order_item updated!');
                  // Trigger lambda function with order, itemId
                  const lambda = new aws.Lambda({
                    region: region,
                    accessKeyId: process.env.AWS_ACCESS_KEY_ID,
                    secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY,
                    apiVersion: '2015-03-31'
                  });
                  const pullParams = {
                    FunctionName: `replace-order-image-${environ}`,
                    InvocationType: 'RequestResponse',
                    LogType: 'Tail',
                    Payload: JSON.stringify({ id: order.id, itemId: thisItem.id, index: index, oldOrder: oldOrder, confirmId: order.confirmId }),
                  };
                  console.log('Invoking Lambda function with Payload: ', pullParams.Payload);
                  lambda.invoke(pullParams, (err, data) => {
                    const res = JSON.parse(data.Payload) || {};
                    console.log('Lambda results: ', data);
                    if (err || res.errorMessage) {
                      console.log('Got an error.', err, res, res.errorMessage)
                      alert('Error replacing image. Try again.');
                      return cb(err, null);
                    }
                    console.log('Got return.');
                    dispatchAction(dispatch, types.ORDER_FETCH_SUCCESS, response.body)
                    alert('Photo replaced / Regenerating PDF. Reload to see changes.');
                    return cb(null, data);
                  });
                })
                .catch(error => console.log(error));
            };
            const reader = new FileReader();
            reader.onloadend = function (ended) {
              console.log('2) read file blob');
              img.src = ended.target.result;
            };
            console.log('1) sending file blob to reader');
            reader.readAsDataURL(file[0]);
          }); // then after upload to s3
      }); // then after s3Policy request
  };
}

export function update_order(orderId, index, value, itemId) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/order/${orderId}`)
      .send({ payload: { index, value } })
      .set({ Authorization: token })
      .then(res => {
        console.log('order items updated!');
        // Trigger lambda function with order, itemId
        const lambda = new aws.Lambda({
          region: region,
          accessKeyId: process.env.AWS_ACCESS_KEY_ID,
          secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY,
          apiVersion: '2015-03-31'
        });
        const pullParams = {
          FunctionName: 'FOCUS-ReplaceOrderItem',
          InvocationType: 'RequestResponse',
          LogType: 'Tail',
          Payload: JSON.stringify({ id: orderId, itemId }),
        };
        console.log('Invoking Lambda function with Payload: ', pullParams.Payload);
        lambda.invoke(pullParams, (err, data) => {
          const res = JSON.parse(data.Payload) || {};
          console.log('Lambda results: ', data);
          if (err || res.errorMessage) {
            console.log('Got an error.');
            alert('Error replacing image. Try again.');
            return cb(err, null);
          }
          console.log('Got return.');
          alert('Photo replaced / Regenerating PDF. Reload to see changes.');
          return cb(null, data);
        });
      })
      .catch(error => console.log(error));
  };
}

// Event actions

export function fetchEvents(route) {
  let routeUrl = `${API_URL_2}/events?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/events`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.EVENTS_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.EVENTS_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchEventsById(eventId) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/events?eventId=${eventId}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.EVENTS_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.EVENTS_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchEvent(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/events/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.EVENT_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.EVENT_FETCH_ERROR, normalizeError(error)));
  };
}
export function fetchEventsLast60() {
  return dispatch => {
    const token = authInfo(dispatch);
    // request.get(`${API_URL_2}/events/last60`)
    request.get('//mp-cloud-api.appspot.com/events/last60') // force use of real data for chart
      .set({ Authorization: token })
      .then(res => {
        console.log('EVENTS: ', res.body);
        dispatchAction(dispatch, types.EVENT_FETCH_LAST60_SUCCESS, res.body)
      })
      .catch(error => dispatchAction(dispatch, types.EVENT_FETCH_LAST60_ERROR, normalizeError(error)));
  };
}
export function fetchOrdersLast60() {
  return dispatch => {
    const token = authInfo(dispatch);
    // request.get(`${API_URL_2}/orders/last60`)
    request.get('//mp-cloud-api.appspot.com/orders/last60') // use real data for chart
      .set({ Authorization: token })
      .then(res => {
        console.log('ORDERS: ', res.body);
        dispatchAction(dispatch, types.ORDER_FETCH_LAST60_SUCCESS, res.body)
      })
      .catch(error => dispatchAction(dispatch, types.ORDER_FETCH_LAST60_ERROR, normalizeError(error)));
  };
}


export function setEvent(data) {
  console.log("SET EVENT DATA", data)
  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/events`)
      .set({ Authorization: token })
      .send(data)
      .then(res => {
        console.log("SET EVENT SUCCESS:", res)
        dispatchAction(dispatch, types.EVENT_SET_SUCCESS, res.body)
        dispatch(fetchEventsById(data.eventId))
      })
      .catch(error => dispatchAction(dispatch, types.EVENT_SET_ERROR, normalizeError(error)));
  };
}

export function deleteEvent(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/events/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.EVENT_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.EVENT_DELETE_ERROR, normalizeError(error)));
  };
}

export function editEvent(orderId, data) {
  console.log("edit Event:", data.event)
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/events/${orderId}`)
      .send(data.event)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.EVENT_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.EVENT_EDIT_ERROR, normalizeError(error)));
  };
}

export function clearEventsErrors() {
  return {
    type: types.EVENTS_CLEAR_ERRORS,
  };
}

// Discounts actions
export function fetchDiscounts(route) {
  let routeUrl = `${API_URL_2}/discounts?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/discounts`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.DISCOUNTS_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.DISCOUNTS_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchDiscount(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/discounts/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.DISCOUNT_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.DISCOUNT_FETCH_ERROR, normalizeError(error)));
  };
}

export function setDiscount(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/discounts`)
      .set({ Authorization: token })
      .send(data)
      .then(res => dispatchAction(dispatch, types.DISCOUNT_SET_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.DISCOUNT_SET_ERROR, normalizeError(error)));
  };
}

export function deleteDiscount(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/discounts/$${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.DISCOUNT_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.DISCOUNT_DELETE_ERROR, normalizeError(error)));
  };
}

export function editDiscount(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/discounts/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => {
        dispatchAction(dispatch, types.DISCOUNT_EDIT_SUCCESS, res.body)
      })
      .catch(error => dispatchAction(dispatch, types.DISCOUNT_EDIT_ERROR, normalizeError(error)));
  };
}
export function pageNavigation(type) {
  console.log("navigateViewDiscount action", type)
  return dispatch => {
    const token = authInfo(dispatch);
    if (type === 'edit') {
      dispatchAction(dispatch, types.NAVIGATION_TYPE, false)
    }
    if (type === 'view') {
      dispatchAction(dispatch, types.NAVIGATION_TYPE, true)
    }
  };
}
export function disableDiscount(pData) {
  const data = pData;
  delete data.items;
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/discounts/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.DISCOUNT_DISABLE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.DISCOUNT_DISABLE_ERROR, normalizeError(error)));
  };
}

export function clearDiscountsErrors() {
  return {
    type: types.DISCOUNTS_CLEAR_ERRORS,
  };
}

// Giftcards actions
export function fetchGiftCards(route) {
  let routeUrl = `${API_URL_2}/giftcards?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/giftcards`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.GIFTCARDS_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.GIFTCARDS_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchGiftCard(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/giftcards/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.GIFTCARD_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.GIFTCARD_FETCH_ERROR, normalizeError(error)));
  };
}

export function setGiftCard(data) {
  console.log("Set GiftCard***", data)
  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/giftcards`)
      .set({ Authorization: token })
      .send(data)
      .then(res => dispatchAction(dispatch, types.GIFTCARD_SET_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.GIFTCARD_SET_ERROR, normalizeError(error)));
  };
}
export function updateGiftCard(id, data) {
  if (data.balance) data.balance = Number(data.balance);
  console.log('UpdateGiftCard**', id, data);
  return dispatch => {
    console.log('token**', token);
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/giftcards/${id}`)
      .set({ Authorization: token })
      .send(data)
      .then(res => dispatchAction(dispatch, types.GIFTCARD_UPDATE_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.GIFTCARD_UPDATE_ERROR, normalizeError(error)));
  };
}
export function deleteGiftCard(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/giftcards/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.GIFTCARD_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.GIFTCARD_DELETE_ERROR, normalizeError(error)));
  };
}

export function editGiftCard(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/giftcards/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.GIFTCARD_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.GIFTCARD_EDIT_ERROR, normalizeError(error)));
  };
}

export function disableGiftCard(id, data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/giftcards/${id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.GIFTCARD_DISABLE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.GIFTCARD_DISABLE_ERROR, normalizeError(error)));
  };
}

export function clearGiftCardsErrors() {
  return {
    type: types.GIFTCARDS_CLEAR_ERRORS,
  };
}


// Promotions actions
export function fetchPromotions(route) {
  let routeUrl = `${API_URL_2}/promotions?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/promotions`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.PROMOTIONS_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.PROMOTIONS_FETCH_ERROR, normalizeError(error)));
  };
}

export function fetchPromotion(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/promotions/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.PROMOTION_FETCH_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.PROMOTION_FETCH_ERROR, normalizeError(error)));
  };
}

export function setPromotion(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/promotions`)
      .set({ Authorization: token })
      .send(data)
      .then(res => dispatchAction(dispatch, types.PROMOTION_SET_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.PROMOTION_SET_ERROR, normalizeError(error)));
  };
}

export function deletePromotion(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/promotions/${id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.PROMOTION_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.PROMOTION_DELETE_ERROR, normalizeError(error)));
  };
}

export function editPromotion(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/promotions/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.PROMOTION_EDIT_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.PROMOTION_EDIT_ERROR, normalizeError(error)));
  };
}

export function disablePromotion(pData) {
  const data = pData;
  delete data.items;
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/promotions/${data.id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.PROMOTION_DISABLE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.PROMOTION_DISABLE_ERROR, normalizeError(error)));
  };
}

export function clearPromotionsErrors() {
  return {
    type: types.PROMOTIONS_CLEAR_ERRORS,
  };
}

// MENU actions
export function menuToggle() {
  return {
    type: types.MENU_TOGGLE,
  };
}

// ARTICLE actions
// Fetch all articles:

export function fetchArticles() {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/articles`)
      .set({ Authorization: token })
      .then(res => {
        dispatchAction(dispatch, types.ARTICLES_FETCH_SUCCESS, res.body.results)
      })
      .catch(error => dispatchAction(dispatch, types.ARTICLES_FETCH_ERROR, normalizeError(error)))
  }
}

//fetch one article by id:
export function fetchArticle(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/articles/${id}`)
      .set({ Authorization: token })
      .then(res => {
        dispatchAction(dispatch, types.ARTICLE_FETCH_SUCCESS, res.body.results)
      })
      .catch(error => dispatchAction(dispatch, types.ARTICLE_FETCH_ERROR, normalizeError(error)))
  }
}

// edit Artcicle:
export function editArticle(data) {
  const Id = data.id
  delete data.id
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/articles/${Id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => { dispatchAction(dispatch, types.ARTICLE_EDIT_SUCCESS, res.body) })
      .catch(error => dispatchAction(dispatch, types.ARTICLE_EDIT_ERROR, normalizeError(error)));
  };
}

//add new article
export function setArticle(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.post(`${API_URL_2}/articles`)
      .set({ Authorization: token })
      .send(data)
      .then(res => dispatchAction(dispatch, types.ARTICLE_SET_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.ARTICLE_SET_ERROR, normalizeError(error)));
  };
}

// delete article
export function deleteArticle(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/articles/${data.id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.ARTICLE_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.ARTICLE_DELETE_ERROR, normalizeError(error)));
  }
}
// clearArticlesErrors
export function clearArticlesErrors() {
  return {
    type: types.ARTICLE_CLEAR_ERRORS,
  };
}
// BOXES ACTIONS
// Fetch all Boxes:
export function fetchBoxes() {
  return dispatch => {
    const token = authInfo(dispatch)
    request.get(`${API_URL_2}/boxes`)
      .set({ Authorization: token })
      .then(res => { dispatchAction(dispatch, types.BOXES_FETCH_SUCCESS, res.body.results) })
      .catch(error => dispatchAction(dispatch, types.BOXES_FETCH_ERROR, normalizeError(error)))
  }
}

// fetch box by id:
export function fetchBox(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/boxes/${id}`)
      .set({ Authorization: token })
      .then(res => { console.log('RESPONSE-->', res.body); dispatchAction(dispatch, types.BOX_FETCH_SUCCESS, res.body.results) })
      .catch(error => dispatchAction(dispatch, types.BOX_FETCH_ERROR, normalizeError(error)));
  };
}

//add new box
export function setBox(data) {
  if (data.weightAvailable) {
    data.weightAvailable = data.weightAvailable.toString()
  }
  return dispatch => {
    const token = authInfo(dispatch)
    request.post(`${API_URL_2}/boxes`)
      .set({ Authorization: token })
      .send(data)
      .then(res => dispatchAction(dispatch, types.BOX_SET_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.BOX_SET_ERROR, normalizeError(error)))
  }
}

// edit box:
export function editBox(data) {
  delete data.updatedAt
  delete data.createdAt
  const Id = data.id
  delete data.id
  if (data.weightAvailable) {
    data.weightAvailable = data.weightAvailable.toString()
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/boxes/${Id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => { dispatchAction(dispatch, types.BOX_EDIT_SUCCESS, res.body) })
      .catch(error => dispatchAction(dispatch, types.BOX_EDIT_ERROR, normalizeError(error)));
  };
}

// delete box:
export function deleteBox(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/boxes/${data.id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.BOX_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.BOX_DELETE_ERROR, normalizeError(error)));
  };
}

export function clearBoxErrors() {
  return {
    type: types.BOX_CLEAR_ERRORS,
  }
}

// OVERLAYS ACTIONS:

// Fetch all Overlays:
export function fetchOverlays(route) {
  let routeUrl = `${API_URL_2}/overlays?page=1`;
  if (route) {
    routeUrl = setRequestUrl(route, `${API_URL_2}/overlays`);
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(routeUrl)
      .set({ Authorization: token })
      .then(res => {
        dispatchAction(dispatch, types.OVERLAYS_FETCH_SUCCESS, res.body);
      })
      .catch(error => dispatchAction(dispatch, types.OVERLAYS_FETCH_ERROR, normalizeError(error)));
  }
}

//add new Overlay
export function setOverlay(data) {
  if (data.weightAvailable) {
    data.weightAvailable = data.weightAvailable.toString()
  }
  return dispatch => {
    const token = authInfo(dispatch)
    request.post(`${API_URL_2}/overlays`)
      .set({ Authorization: token })
      .send(data)
      .then(res => dispatchAction(dispatch, types.OVERLAY_SET_SUCCESS, res.body))
      .catch(error => dispatchAction(dispatch, types.OVERLAY_SET_ERROR, normalizeError(error)))
  }
}

// fetch overlay by id:
export function fetchOverlay(id) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.get(`${API_URL_2}/overlays/${id}`)
      .set({ Authorization: token })
      .then(res => { console.log('fetchOverlay RESPONSE-->', res.body); dispatchAction(dispatch, types.OVERLAY_FETCH_SUCCESS, res.body) })
      .catch(error => dispatchAction(dispatch, types.OVERLAY_FETCH_ERROR, normalizeError(error)));
  };
}

// edit overlay:
export function editOverlay(data) {
  delete data.updatedAt
  delete data.createdAt
  const Id = data.id
  delete data.id
  if (data.weightAvailable) {
    data.weightAvailable = data.weightAvailable.toString()
  }
  return dispatch => {
    const token = authInfo(dispatch);
    request.patch(`${API_URL_2}/overlays/${Id}`)
      .send(data)
      .set({ Authorization: token })
      .then(res => { dispatchAction(dispatch, types.OVERLAY_EDIT_SUCCESS, res.body) })
      .catch(error => dispatchAction(dispatch, types.OVERLAY_EDIT_ERROR, normalizeError(error)));
  };
}

// delete overlay:
export function deleteOverlay(data) {
  return dispatch => {
    const token = authInfo(dispatch);
    request.delete(`${API_URL_2}/overlays/${data.id}`)
      .set({ Authorization: token })
      .then(res => dispatchAction(dispatch, types.OVERLAY_DELETE_SUCCESS, res))
      .catch(error => dispatchAction(dispatch, types.OVERLAY_DELETE_ERROR, normalizeError(error)));
  };
}

export function clearOverlayErrors() {
  return {
    type: types.OVERLAY_CLEAR_ERRORS,
  }
}


// WEBPACK FOOTER //
// ./src/actions/index.js